import PropTypes from 'prop-types'
import { useSnackbar } from 'notistack'

import { useRef, useState } from 'react'
import { Link as RouterLink, useNavigate } from 'react-router-dom'

import useAuth from '../../hooks/useAuth'
import useIsMountedRef from '../../hooks/useIsMountedRef'

import { PATH_DASHBOARD, PATH_AUTH } from '../../routes/paths'

import { alpha } from '@mui/material/styles'
import {
  Button,
  Box,
  Divider,
  MenuItem,
  Typography,
  Avatar,
  IconButton,
} from '@mui/material'

import Iconify from '../../components/Iconify'
import MenuPopover from '../../components/MenuPopover'

import account from '../../_mocks_/account'

const MENU_OPTIONS = [
  {
    label: 'خانه',
    icon: 'eva:home-fill',
    linkTo: '/',
  },
  {
    label: 'پروفایل',
    icon: 'eva:person-fill',
    linkTo: '/dashboard/profile',
  },
]

export default function AccountPopover() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()
  const isMountedRef = useIsMountedRef()

  const { enqueueSnackbar } = useSnackbar()

  const anchorRef = useRef(null)
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  const handleLogout = async () => {
    try {
      await logout()
      navigate(PATH_AUTH.login, { replace: true })

      if (isMountedRef.current) {
        handleClose()
      }
    } catch (error) {
      console.error(error)
      enqueueSnackbar('Unable to logout!', { variant: 'error' })
    }
  }

  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 44,
          height: 44,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.72),
            },
          }),
        }}
      >
        <Avatar src={account.photoURL} alt='photoURL' />
      </IconButton>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant='subtitle1' noWrap>
            {user.firstName} {user.lastName}
          </Typography>
          <Typography variant='body2' sx={{ color: 'text.secondary' }} noWrap>
            {user.phoneNumber}
          </Typography>
        </Box>

        <Divider sx={{ my: 1 }} />

        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.label}
            to={option.linkTo}
            component={RouterLink}
            onClick={handleClose}
            sx={{ typography: 'body2', py: 1, px: 2.5 }}
          >
            <Iconify
              icon={option.icon}
              sx={{
                mr: 2,
                width: 24,
                height: 24,
              }}
            />

            {option.label}
          </MenuItem>
        ))}

        <Box sx={{ p: 2, pt: 1.5 }}>
          <Button
            onClick={handleLogout}
            fullWidth
            color='inherit'
            variant='outlined'
          >
            خروج
          </Button>
        </Box>
      </MenuPopover>
    </>
  )
}

AccountPopover.propTypes = {
  user: PropTypes.object,
}
